import React from 'react';
import { FileText, ChevronRight } from 'lucide-react';
export function Newsletters2019Section() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-3309">
      <div className="bg-[#1874cd] py-4 px-6" data-id="element-3310">
        <h2 className="text-2xl font-bold text-white" data-id="element-3311">Newsletters - 2019</h2>
      </div>
      <div className="p-8" data-id="element-3312">
        <ul className="space-y-4" data-id="element-3313">
          <li className="flex items-start" data-id="element-3314">
            <FileText className="h-5 w-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-3315" />
            <a href="https://www.peakedm.com/uploaded/files/Advancements%20in%20EDM%20-%20October%202019.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="text-lg text-gray-700 hover:text-orange font-medium transition-colors" data-id="element-3316">
              Advancements in EDM - October 2019
            </a>
          </li>
          <li className="flex flex-col" data-id="element-3317">
            <div className="flex items-start" data-id="element-3318">
              <FileText className="h-5 w-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-3319" />
              <a href="https://www.peakedm.com/uploaded/files/Mikron%20MILL%20S%20-%20October%202019.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="text-lg text-gray-700 hover:text-orange font-medium transition-colors" data-id="element-3320">
                Mikron MILL S - October 2019
              </a>
            </div>
            <ul className="ml-8 mt-2 space-y-2" data-id="element-3321">
              <li className="flex items-center" data-id="element-3322">
                <ChevronRight className="h-4 w-4 text-gray-400 mr-2" data-id="element-3323" />
                <a href="https://www.peakedm.com/uploaded/files/Mikron%20MILL%20S%20-%20October%202019.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-orange transition-colors" data-id="element-3324">
                  High Speed Hard Milling & Graphite Machining Solutions
                </a>
              </li>
            </ul>
          </li>
          <li className="flex items-start" data-id="element-3325">
            <FileText className="h-5 w-5 text-orange mr-3 mt-0.5 flex-shrink-0" data-id="element-3326" />
            <a href="https://www.peakedm.com/uploaded/files/2019%20Year%20End%20Rally.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="text-lg text-gray-700 hover:text-orange font-medium transition-colors" data-id="element-3327">
              2019 Year End Rally
            </a>
          </li>
        </ul>
      </div>
    </div>;
}